import styles from './header-links.module.scss'
import { Link } from 'react-router'
import { PathUtils } from 'routes/routes.utils'
import { useAuth } from 'app/providers/auth/AuthProvider'

import { Menu, type MenuProps } from 'antd'
import { type IUser } from 'common/interfaces/IUser'

const HeaderLinks = () => {
  const { user } = useAuth()

  const menuItems = getItems(user)

  return <Menu mode='horizontal' items={menuItems} rootClassName={styles.headerLinksContainer} />
}

export default HeaderLinks

const getItems = (user: IUser | null): MenuProps['items'] => [
  {
    label: 'What Is Residen?',
    key: 'what-is-residen',
    children: [
      {
        type: 'group',
        label: (
          <a
            href='https://www.residen.com/the-residen-difference'
            target='_blank'
            rel='noopener noreferrer'>
            The Residen Difference
          </a>
        ),
      },
      {
        type: 'group',
        label: (
          <a href='https://www.residen.com/our-mission' target='_blank' rel='noopener noreferrer'>
            Our Mission
          </a>
        ),
      },
    ],
  },
  {
    label: (
      <a href='https://www.residen.com/residen-locations' target='_blank' rel='noopener noreferrer'>
        Locations
      </a>
    ),
    key: 'locations',
  },
  {
    label: (
      <a href='https://www.residen.com/pricing' target='_blank' rel='noopener noreferrer'>
        Pricing
      </a>
    ),
    key: 'pricing',
  },
  {
    label: (
      <a href='https://www.residen.com/lower-overhead' target='_blank' rel='noopener noreferrer'>
        Lower Overhead
      </a>
    ),
    key: 'lower-overhead',
  },
  {
    label: 'Getting Started',
    key: 'getting-started',
    children: [
      {
        type: 'group',
        label: (
          <a href='https://www.residen.com/get-started' target='_blank' rel='noopener noreferrer'>
            Get Started
          </a>
        ),
      },
      ...(!user
        ? [
            {
              type: 'group' as const,
              label: <Link to={PathUtils.getRegister()}>Sign Up</Link>,
            },
          ]
        : []),
    ],
  },
  {
    label: (
      <a href='https://www.residen.com/blog' target='_blank' rel='noopener noreferrer'>
        Blog
      </a>
    ),
    key: 'blog',
  },
  {
    label: (
      <a href='https://www.residen.com/contact' target='_blank' rel='noopener noreferrer'>
        Contact
      </a>
    ),
    key: 'contact',
  },
]
